import {
  localesHg_de as domusPlatformTranslations,
  localesDomus_de as domusTranslations,
} from '@smg-real-estate/domus';
import merge from 'lodash.merge';

import appTranslations from './locales/de-CH.json';

export default merge({}, domusTranslations, domusPlatformTranslations, appTranslations);
